import { TableCell, TableRow, Tooltip } from "@mui/material";
import { TIdForCTM, TTableColumn } from "../../types";
import CustomTableCell from "./tableCellMaterial";

type TCustomTableRowProps = {
  row: TIdForCTM & any;
  columns: TTableColumn[];
  component?: any;
  linkTo?: string;
  tooltip?: string;
  onClick?: (e: any) => void;
  expandableRow?: boolean;
  expandedRowFormat?: (row: any) => JSX.Element;
  openedRow?: number;
  setOpenedRow?: (rowId: number) => void;
};

function CustomTableRow<T>(props: TCustomTableRowProps) {
  const {
    row,
    columns,
    component,
    linkTo,
    tooltip,
    onClick,
    expandableRow,
    expandedRowFormat,
    openedRow,
    setOpenedRow,
  } = props;

  let expandedRow = <></>;
  if (expandableRow && openedRow === row.id) {
    expandedRow = (
      <TableRow key={"ebr"} style={{ backgroundColor: "#18334530" }}>
        <TableCell
          key={"erc"}
          colSpan={columns.length + columns.filter((c) => c.expandable).length}
        >
          {expandedRowFormat!(row)}
        </TableCell>
      </TableRow>
    );
  }

  const onExpand = () => {
    if (openedRow != -1) setOpenedRow && setOpenedRow(-1);
    else setOpenedRow && setOpenedRow(row.id);
  };

  const tableRow = (
    <>
      <TableRow
        onClick={expandableRow ? onExpand : onClick}
        component={component}
        linkto={linkTo}
        hover
        tabIndex={-1}
        key={row.id}
      >
        {columns.map((column) => {
          const value = row[column.id as keyof T];
          return (
            <CustomTableCell
              key={column.id.toString() + row.id}
              column={column}
              rowNumber={row.id}
              row={row}
              value={value}
              format={column.format}
              stylef={column.stylef}
              linkTo={column.linkTo}
              expandable={column.expandable}
              expandedFormat={column.expandedFormat}
            />
          );
        })}
      </TableRow>
      {expandedRow}
    </>
  );

  return tooltip ? (
    <Tooltip
      title={tooltip}
      enterDelay={2000}
      enterNextDelay={2000}
      key={row.id || row.course_id}
      leaveDelay={0}
    >
      {tableRow}
    </Tooltip>
  ) : (
    tableRow
  );
}

export default CustomTableRow;
